import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';
import {
  formatSnProductMappingStatusLabel,
} from '#/modules/crmMgmt/aftersales/snProductMapping/helper/snProductMappingStatus';

const SnProductMappingStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={formatSnProductMappingStatusLabel(status)}
    size={size}
    className={className}
  />
);

SnProductMappingStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export default SnProductMappingStatusBadge;
